import { render, staticRenderFns } from "./orderedit.vue?vue&type=template&id=0d00b127&scoped=true&"
import script from "./orderedit.vue?vue&type=script&lang=js&"
export * from "./orderedit.vue?vue&type=script&lang=js&"
import style0 from "./orderedit.vue?vue&type=style&index=0&id=0d00b127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d00b127",
  null
  
)

export default component.exports